<template>
  <!-- for scroll position -->
  <div ref="scrollToElement" />
  <filter-header
    :show-filter-mode="showFilterMode"
    :toggle-show-mode="toggleShowMode"
    :has-filter="hasFilter"
    :clear-all-filter="clearAllFilter"
    :total-record="projectStats?.page?.totalRecord"
  >
    <template #query-fields>
      <div class="control is-expanded line">
        <!-- <basic-dropdown
          v-model="queryParam.categoryId"
          :options="tagOptions?.categories"
          :is-option-map="false"
          :label="$t('project.column.categories')"
          @update:model-value="updateFilter"
        /> -->
        <!-- <basic-dropdown
          v-model="queryParam.categoryId"
          :options="tagOptions?.categories"
          :is-option-map="false"
          :label="$t('project.column.categories')"
          @update:model-value="updateFilter"
        /> -->
        <SingleCountDropdown
          v-model="queryParam.categories"
          :label="$t('project.column.categories')"
          :stats="categoryCountsMap"
          @update:model-value="updateFilter"
        />
      </div>

      <div class="control is-expanded searchWrap">
        <div class="searchHeader">
          Or Search
        </div>
        <selection-input
          v-model="queryParam.searchText"
          :label="$t('common.search')"
          @update:model-value="updateSearchKey"
        />
      </div>
    </template>
    <!-- end of selection input box -->
    <template #query-display>
      <template
        v-for="(field, fieldKey) in projectDisplayLabelForQuery"
        :key="'query' + fieldKey"
      >
        <ShowQueryText
          :field-key="fieldKey"
          :label="field.label"
          :query-param="queryParam"
          :clear-query-item="clearQueryItem"
          :class-style="'tag is-light filter ' + field.css"
        />
      </template>
    </template>
  </filter-header>

  <ProjectList
    :data-list="projectList"
    :query-param="queryParam"
    :total-record="projectStats.page?.totalRecord"
  >
    <template #bottom-pagination>
      <common-pagination
        :total-page-in-view="pageInView"
        :total-page="projectStats.page?.totalPage ?? 1"
        :current-page-number="queryParam?.page ?? 1"
        :additional-action="scrollToTop"
        :update-page="updatePage"
      />
    </template>
  </ProjectList>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { projectSearchState } from '@/composables/state/projectSearchApp';
import FilterHeader from '../../components/FilterHeader.vue';
import SingleCountDropdown from '../../components/dropdown/SingleCountDropdown.vue';
import SelectionInput from '../../components/search/SelectionInput.vue';

import CommonPagination from '../../components/CommonPagination.vue';
// import BasicDropdown from '../../components/dropdown/BasicDropdown.vue';
import ShowQueryText from '../../components/ShowQueryText.vue';
import ProjectList from './ProjectList.vue';
import { projectDisplayLabelForQuery } from '@/config/index';

const props = defineProps({
  rootPath: { type: String, default: '' }
});
// categoryCounts,
const {
  projectList, categoryCountsMap, defaultQueryParam, queryParam, projectStats, clearQueryItem, clearAllFilter, updatePage
} = projectSearchState();
// eslint-disable-next-line vue/no-setup-props-destructure
defaultQueryParam.rootPath = props.rootPath;
// eslint-disable-next-line vue/no-setup-props-destructure
queryParam.value.rootPath = props.rootPath;
watch(() => props.rootPath, () => {
  defaultQueryParam.rootPath = props.rootPath;
  queryParam.value.rootPath = props.rootPath;
});

// const searchKey = ref('');
const updateSearchKey = (e:string) => {
  queryParam.value.page = 1;
  queryParam.value.searchText = e;
};
const toggleShowMode = () => {
  showFilterMode.value = !showFilterMode.value;
};
const updateFilter = () => {
  queryParam.value.page = 1;
};

const hasFilter = computed(():boolean => {
  return (queryParam.value != null) && (
    (queryParam.value?.categories != null || (queryParam.value.searchText ?? '').length > 0)
  );
});

const pageInView = 5;

const showFilterMode = ref(true);
const scrollToElement = ref<HTMLInputElement | null>(null);

const scrollToTop = () => {
  if (scrollToElement.value) {
    scrollToElement.value.scrollIntoView({ behavior: 'smooth' });
  }
};

</script>

<style scoped>
.searchHeader {
  margin-top: -40px;
  font-weight: bold;
  padding-bottom: 10px;
  font-size: large;
}

@media screen and (max-width: 820px){  /* Adjust based on your layout and tooltip size */
  .searchHeader {
      margin-top: 0px;
      font-weight: bold;
      padding-bottom: 10px;
      font-size: large;
  }
}

.field.is-grouped .control.is-expanded.line:after {
    content: "";
    border-right: 1px solid #bbbbbb;
    display: block;
    height: 40px;
    padding-left: 1.5rem;
    margin-top:-45px;
}
</style>
